import React, {useState} from "react";
import ArrowLeftIcon from "../ArrowLeftIcon";
import {useLanguage} from "../../hooks/LanguageContext";
import {Link} from "react-router-dom"; // Import the language hook

const links = [
	{ href: "/", text_ltr: "Home", text_rtl: "الرئيسية" },
	{ href: "/about", text_ltr: "About Us", text_rtl: "من نحن" },
	{ href: "/services", text_ltr: "Services", text_rtl: "خدماتنا" },
	{ href: "/partners", text_ltr: "Partners", text_rtl: "شركاؤنا" },
	{ href: "/branches", text_ltr: "Branches", text_rtl: "فروعنا" },
	{ href: "/contactus", text_ltr: "Contact Us", text_rtl: "تواصل معنا" },
	{ href: "/terms-conditions", text_ltr: "Terms and Conditions", text_rtl: "الشروط و الاحكام" },
	{ href: "/shipping-agreement", text_ltr: "Shipping Agreement", text_rtl: "اتفاقية الشحن" },
];

const FooterLinksBox = () => {
	const [activeLink, setActiveLink] = useState("/");
	const { direction } = useLanguage(); // Get the language direction (LTR or RTL)

	const handleLinkClick = (href) => {
		setActiveLink(href);
	};

	return (
		<section>

			<h4
				className={`headline-4-ar text-grayscale-700 ${
					direction === "rtl" ? "text-right" : "text-left"
				} mb-[25px]`}
			>
				{direction === "ltr" ? "Al-Fayez Group" : "الفايز جروب"}
			</h4>
			<ul className="md:w-[398px] w-full flex items-start gap-x-[90px] gap-y-5 flex-wrap">
				{links.map((link, index) => (
					<li key={index} className="w-[70px] flex items-center justify-start gap-1">

						<Link
							className={`text-base whitespace-nowrap font-medium transition-colors delay-300 ease-in-out ${
								activeLink === link.href
									? "text-primary-700"
									: "text-gray-600 hover:text-primary-700"
							}`}
							to={link.href}
							onClick={() => handleLinkClick(link.href)}
						>
							{activeLink === link.href && <ArrowLeftIcon className="inline-block" />}
							{direction === "ltr" ? link.text_ltr : link.text_rtl}
						</Link>
					</li>
				))}
			</ul>
		</section>
	);
};

export default FooterLinksBox;
